import { render } from "./SpmSortInput.vue?vue&type=template&id=ebc8e3e0&scoped=true"
import script from "./SpmSortInput.vue?vue&type=script&lang=ts"
export * from "./SpmSortInput.vue?vue&type=script&lang=ts"

import "./SpmSortInput.vue?vue&type=style&index=0&id=ebc8e3e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ebc8e3e0"

export default script